/**
 * The filter-change reasons MUI 6 gives a user's own Filters-panel edit — the
 * only filter changes a grid stages for Display Preferences → Save. Any other
 * change (restoreState, a grid's own upsertFilterItems restore or advanced
 * search, a reason-less sync or the quick-search clear) is not one the user
 * asked to save.
 */
export const USER_FILTER_EDIT_REASONS: ReadonlySet<string> = new Set([
  "upsertFilterItem",
  "deleteFilterItem",
  "changeLogicOperator",
  "removeAllFilterItems",
]);
